import { FC } from "react";
import { LegacyDesktopFooter } from "../../widgets/footer";
import { LegacyDesktopHeader } from "../../widgets/header";
import { useLocation } from "react-router";

const isFullSize = (path: string) => {
    return (
        path.includes('/fan-app')
        || path.includes('/fan-mvp')
        || path.includes('/club-100')
        || path.includes('/news')
        || path.includes('/matchcenter')
        || path.includes('/stadium')
    )
}

interface LegacyDesktopLayoutProps {
    children?: React.ReactNode;
}

export const LegacyDesktopLayout: FC<LegacyDesktopLayoutProps> = ({
    children,
}) => {
    const location = useLocation();
    const bgUrl = ` bg-[url(https://fcrodina.com/static/images/bg/rodina.jpg)]`;
    const bgClass = "bg-fixed" + bgUrl;
    let contentClass = "w-full bg-white/95";
    if (!isFullSize(location.pathname)) {
        contentClass += " max-w-[965px] mx-auto";
    }
    return (
        <div className={bgClass}>
            <LegacyDesktopHeader />
            <div className={contentClass} style={{ fontFamily: 'Futura, sans-serif' }}>
                {children}
            </div>
            <LegacyDesktopFooter />
        </div>
    );
}
